import { createFileRoute } from '@tanstack/react-router';
import { ChainHomeRouter } from '@/pages/dashboard/chain/ChainHomeRouter';
import { prefetchChainHomeBootQueries, prefetchDashboardBootQueries } from '@/pages/dashboard/dashboard-boot-queries';

export const Route = createFileRoute('/_authenticated/_app/dashboard')({
	// Kicks the dashboard's own queries off as soon as the route matches, rather than waiting for
	// chain membership to resolve and the widgets to mount. Nothing is awaited, so navigation here is
	// never delayed by them. If hydrate has not settled on a company yet the prefetch skips and the
	// widgets fetch normally.
	loader: ({ context }) => {
		const company = context.globalStore.getState().currentCompany;
		const companyId = company?.id ?? '';
		prefetchDashboardBootQueries({ queryClient: context.queryClient, companyId });
		// For a chain parent, overlap its widget data with the lazy chain-home chunk download instead
		// of firing at mount; gated on aggregated counts, so members and single companies skip it.
		void prefetchChainHomeBootQueries({
			queryClient: context.queryClient,
			companyId,
			disabledModules: company?.disabledModules,
		});
	},
	component: ChainHomeRouter,
});
